import { Breadcrumbs } from "../components/global/Breadcrumbs"
import { useState, useContext, useEffect } from "react"
import { MobileCartItem } from "../components/cart/MobileCartItem"
import { CartItem } from "../components/cart/CartItem"
import { CartTotal } from "../components/cart/CartTotal"
import { CustomButton } from "../components/global/CustomButton"
import { UserContext } from "../contexts/UserContext"
import { handleUpdateArray } from "../functions/UpdateUser"
import "./cart.css"

export function Cart(){
    const [subtotal, setSubtotal] = useState(0)
    const [cartClone, setCartClone] = useState(null)

    const userDataContext = useContext(UserContext)
    const { user } = userDataContext

    useEffect(() => {
        let subtotal = 0
        
        if(user) {
            user.cart.map(e => subtotal += (e.quantity * e.salePrice))
            setSubtotal(subtotal)
            setCartClone(user.cart)
        }
    }, [user])

    useEffect(() => {
        let subtotal = 0
        
        cartClone && cartClone.map(
            e => subtotal += (e.quantity * (e.salePrice ? e.salePrice : e.regularPrice))
        )
        setSubtotal(subtotal)
    }, [cartClone])

    function handleUpdateCart() {
        const updatePayload = { updatedCart: cartClone, subtotal }
        handleUpdateArray(cartClone, "UPDATE_CART", updatePayload, userDataContext)
    }

    return (
        <div className="cart-page mx-auto">

            <Breadcrumbs dynamicPath="Cart" />

            <div className="cart-items-mobile flx-lg-off">
                {
                    cartClone && cartClone.map((e, i) => (
                        <MobileCartItem
                            key={i}
                            itemId={e.customId}
                            cartItem={e}
                            itemQuantity={e.quantity}
                            cartClone={cartClone}
                            setCartClone={setCartClone}
                        />
                    ))
                }
            </div>
            
            <table className="w-100">
                <tbody>
                    <tr className="justify-content-between px-4 py-3 cart-table off-lg-flx">
                        <td>Product</td>
                        <td>Price</td>
                        <td className="ps-3">Quantity</td>
                        <td>Subtotal</td>
                    </tr>
                </tbody> 
            </table>

            <table className="w-100 mt-5">
                <tbody className="d-flex flex-column gap-4">
                    {
                        cartClone && cartClone.map(e => (
                            <CartItem
                                key={e.customId}
                                itemId={e.customId}
                                cartItem={e}
                                itemQuantity={e.quantity}
                                cartClone={cartClone}
                                setCartClone={setCartClone}
                            />
                        ))
                    }
                </tbody>
            </table>

            <div className="d-flex justify-content-between mt-4">
                <CustomButton
                    btnLink={true}
                    path="/shop"
                    color="default"
                    text="Return To shop"
                />
                <CustomButton
                    color="default"
                    text="Update Cart"
                    btnFunction={handleUpdateCart}
                />
            </div>

            <CartTotal
                cartClone={cartClone}
                subtotal={subtotal}
            />

        </div>
    )
}